import { createPortal, useRef } from 'preact/compat'
import { FilterToggleButton, SortToggleButton } from '@/components/custom-elements/searchspring-buttons'

export const SearchHeader = ({ query, totalResults, isLoading, corrections }) => {
  const searchHeader = document.querySelector('#search-results')
  const content = useRef(searchHeader ? searchHeader.innerHTML : '')
  const hasMounted = useRef(false)

  if (!searchHeader) {
    return null
  }

  if (!hasMounted.current) {
    hasMounted.current = true
    searchHeader.innerHTML = ''
  }

  return createPortal(
    (hasMounted.current || !isLoading) && (
      <>
        <div
          className={`grow flex flex-col gap-y-0.75 lg-max:w-full ${totalResults > 0 ? 'search-mounted' : ''}`}
          data-results={totalResults}
        >
          <h2 className="h3 font-semibold w-full">
            {totalResults === 0 ? 'No' : totalResults} Results For "{corrections?.corrected ? corrections?.corrected : query}"
          </h2>
          {corrections?.corrected && (
            <div className="paragraph-s">
              <p>No results found for "{query}". Showing results for "{corrections.corrected}" instead.</p>
            </div>
          )}
          {corrections?.didYouMean && (
            <div className="paragraph-s">
              <p>Did you mean: <a href={`/search?query=${corrections.didYouMean}`} className='link-fade' aria-label={`Search for ${corrections.didYouMean}`}>{corrections.didYouMean}</a></p>
            </div>
          )}
          {totalResults === 0 && !isLoading && (
            <div className={'[&>div]:!block'} dangerouslySetInnerHTML={{ __html: content.current }} />
          )}
        </div>
        {totalResults > 0 && (
          <div className="hidden lg:flex items-end">
            <FilterToggleButton
              className="btn btn-custom btn-transparent btn-m w-fit"
              iconClass="w-[12px] h-[8px]"
            />
            <SortToggleButton
              className="btn btn-custom btn-transparent btn-m w-fit"
              iconClass="w-[13px] h-[12px]"
            />
          </div>
        )}
      </>
    ), searchHeader
  )
}
